import { useSearchParams } from "react-router-dom";
import { search } from "../api/content";
import { SearchExperience } from "../components/search/SearchExperience";

/**
 * Site-wide search across every content type — photographs, films, journal
 * entries, and external references. Reuses the exact same faceted experience as
 * the Journal, differing only in the endpoint it queries.
 *
 * Seeds the query box from a `?q=` URL parameter so the header search box and
 * deep links land here pre-filled.
 */
export function SearchPage() {
  const [params] = useSearchParams();
  const initialQuery = params.get("q") ?? "";

  return (
    <div className="page">
      <div className="container">
        <header className="page__head">
          <p className="eyebrow">Master index · Everything</p>
          <h1 className="page__title">Search</h1>
          <p className="page__intro">
            One query across everything on the site — posts, photos, videos, and
            links. Filter by type or tag, sort by date, title, or relevance, and
            page through the results.
          </p>
        </header>

        {/* `key` forces a fresh mount when the seed query changes, so navigating
            here from different links re-seeds the box cleanly. */}
        <SearchExperience
          key={initialQuery}
          fetcher={search}
          initialQuery={initialQuery}
          placeholder="Search everything — photos, videos, posts, links…"
          emptyLabel="Nothing matches that search."
        />
      </div>
    </div>
  );
}
